import type { ReactNode } from "react";

export interface ErrorStateProps {
  /** The problem, in plain words. */
  children: ReactNode;
  /** The recovery: a retry or a way out. Always offer one. */
  action?: ReactNode;
}

/** Error state: names the problem and gives a recovery action. Announced to assistive tech. */
export function ErrorState({ children, action }: ErrorStateProps) {
  return (
    <div
      role="alert"
      className="flex flex-col gap-3 rounded-panel bg-red-wash px-5 py-4 sm:flex-row sm:items-center sm:justify-between"
    >
      <p className="text-operate font-medium text-red">{children}</p>
      {action}
    </div>
  );
}
